import { LocationUTM } from '~types/Location.types';

export enum LocalStorageKeys {
  LandingsEntryPage = 'landingsEnterPage',
  LandingsRefPage = 'landingsRedirectFrom',
  LandingsUtmData = 'landingsUtmData',
}

export type LocalStorageData = {
  [LocalStorageKeys.LandingsEntryPage]: {
    pathname: string;
    utm?: Partial<Record<LocationUTM, string>>;
  };
  [LocalStorageKeys.LandingsRefPage]: string;
  [LocalStorageKeys.LandingsUtmData]: Partial<Record<LocationUTM, string>>;
};
